global.$ = global.jQuery = require('jquery');
const slick = require('slick-carousel');
require("@fancyapps/fancybox");
var resizeTimerInternal;
const jQueryBridget = require('jquery-bridget');
const InfiniteScroll = require('infinite-scroll');
var params = {};
var reset = false;

// make Infinite Scroll a jQuery plugin
jQueryBridget( 'infiniteScroll', InfiniteScroll, $ );

jQuery(document).ready(function($) {
	/* Responsive Jquery Navigation */
	/*$(document).on('click','.hamburger',function(){
		$('.mbnav').toggleClass('left-0');
		$('.mbnav').addClass('translate-x-[100%]');
		$('.mbnav').removeClass('translate-x-[0]');
		$('.mbnav').toggleClass('-left-full');
	});

	$(document).on('click','.mbbg',function(){
		$('.mbnav').toggleClass('-left-full');
	});*/

    $('.hamburger').on('click', function() {
    	$('.mbnav').show();
    	$('.mbnav').toggleClass('translate-x-full');
    });

	function cycleImages(container){
		var $active = container.find('div.active');
		var $activeDot = container.find('span a.active:first');
		var $next = ($active.next('div').length > 0) ? $active.next('div') : container.find('div:first');
		var $nextDot = ($activeDot.next('a').length > 0) ? $activeDot.next('a') : container.find('span a.cycler-dot:first');
		$next.css('z-index',2); //move the next image up the pile
		$active.fadeOut(1250,function(){ //fade out the top image
			$active.css('z-index',1).show().removeClass('active'); //reset the z-index and unhide the image
			$activeDot.removeClass('active');
			$next.css('z-index',3).addClass('active'); //make the next image the top one
			$nextDot.addClass('active');
		});
		var timer = setTimeout(function(){cycleImages(container)},5500);
		container.data('timer',timer);
  	}

	function pauseSlideshow(container){
		clearInterval(container.data('timer'));
		container.find('div.active').stop(true,true);
		//container.find('#pause_resume').html('Resume').toggleClass('active');
	}

	if($('.cycler').length) {

		var i = 1;
		$('.cycler').each(function(){
			var container = $(this);
			container.append('<span class="cycler-pager block absolute z-40 bottom-0 w-full flex flex-row items-center justify-center space-x-2 pb-2 transform -translate-y-full">');
			for (var j=0;j<=container.find('div').length-1;j++){
				container.find('.cycler-pager').append('<a class="cycler-dot" href="#" rel="'+j+'"></a>');
			}
			$('.cycler-dot:first').addClass('active');
			container.append('</span>').addClass('cycler'+i);
			var timer = setTimeout(function(){cycleImages(container)}, 1500);
			container.data('timer',timer);
			i++;
		});

		$('.cycler-pager a.cycler-dot').click(function(){
			$(this).addClass('active').siblings().removeClass('active');
			var container = $(this).parents('.cycler');
			//pauseSlideshow(container);
			container.find('div').eq($(this).attr('rel')).css('z-index',4).addClass('clicked'); //set the clicked image to the top
			container.find('div.active').not('.clicked').removeClass('active').css('z-index',1); //if the active image is not the clicked image, remove the active class
			container.find('.clicked').addClass('active').removeClass('clicked'); //set the active class on the clicked image ready to resume
			return false;
		});
	}

	/* menu open and close on single click */
	$(document).on('click','.mbnav .has-sub>.down-arrow',function(){
		var element = $(this).parent('li');
		if (element.hasClass('is-open')) {
			element.removeClass('is-open');
			element.find('li').removeClass('is-open');
			element.find('ul').slideUp(200);
		}
		else {
			element.addClass('is-open');
			element.children('ul').slideDown(200);
			element.siblings('li').children('ul').slideUp(200);
			element.siblings('li').removeClass('is-open');
			element.siblings('li').find('li').removeClass('is-open');
			element.siblings('li').find('ul').slideUp(200);
		}
	});

	// Navigation Menu
	$(document).on('mouseover','.parent-node',function(){
		$('.submenu-node').hide();
		$(this).siblings('.submenu-node').show();
		$(this).siblings('.submenu-node').removeClass('opacity-0 -translate-y-1');
		$(this).siblings('.submenu-node').addClass('opacity-100 translate-y-0');
	});

	$(document).on('mousemove', function(e) {
	    if (!$(e.target).closest('.submenu-node, .parent-node').length) {
	      $('.submenu-node').hide();
	      $('.submenu-node').removeClass('opacity-100 translate-y-0');
	      $('.submenu-node').addClass('opacity-0 -translate-y-1');
	    }
	});

	$('.meet-slider').slick({
	    dots: true,
	    infinite: false,
	    speed: 500,
		slidesToShow: 5,
	    slidesToScroll: 5,
	    prevArrow : '<span class="slick-prev slick-arrow cursor-pointer absolute -left-12 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><path d="M25.9,32h-9.96a.7.7,0,0,1-.491-.2L.2,16.512a.7.7,0,0,1,0-.982L15.439.206A.7.7,0,0,1,15.932,0h9.963a.7.7,0,0,1,.494,1.187L11.879,15.776a.348.348,0,0,0,0,.491L26.394,30.812A.7.7,0,0,1,25.9,32Z" fill="#7f9fa6"/></svg></span>',
	    nextArrow : '<span class="slick-next slick-arrow cursor-pointer absolute -right-12 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><g  transform="translate(26.599)"><path d="M-25.9,32h9.96a.7.7,0,0,0,.491-.2L-.2,16.512a.7.7,0,0,0,0-.982L-15.439.206A.7.7,0,0,0-15.932,0h-9.963a.7.7,0,0,0-.643.428.7.7,0,0,0,.15.758l14.51,14.589a.348.348,0,0,1,0,.491L-26.394,30.812a.7.7,0,0,0-.151.759A.7.7,0,0,0-25.9,32Z" fill="#7f9fa6"/></g></svg></span>',
	    responsive: [
	        {
	            breakpoint: 1380,
	            settings: {
	                slidesToShow: 3,
					slidesToScroll: 3,
	            }
	        },
	        {
	            breakpoint: 768,
	            settings: {
	                slidesToShow: 2,
					slidesToScroll: 2,
	            }
	        },
	        {
	            breakpoint: 640,
	            settings: {
	                slidesToShow: 1,
					slidesToScroll: 1,
	            }
	        }
	    ]
	});

	$(window).on('resize', function() {
		clearTimeout(resizeTimerInternal)

		resizeTimerInternal = setTimeout(function() {
			//add functions here to fire on resize
			slickSliderWithResize();
		}, 100)
	});

	function slickSliderWithResize() {
	  	if ($(window).width() <= 1488) {
		    if($('.logo-slider').hasClass('slick-initialized')) {

		    }
		    else {
		      $('.logo-slider').slick({
		          	dots: true,
		          	infinite: false,
		          	speed: 500,
		      		slidesToShow: 1,
		          	slidesToScroll: 1,
		          	prevArrow : '<span class="slick-prev slick-arrow cursor-pointer absolute left-0 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><path d="M25.9,32h-9.96a.7.7,0,0,1-.491-.2L.2,16.512a.7.7,0,0,1,0-.982L15.439.206A.7.7,0,0,1,15.932,0h9.963a.7.7,0,0,1,.494,1.187L11.879,15.776a.348.348,0,0,0,0,.491L26.394,30.812A.7.7,0,0,1,25.9,32Z" fill="#7f9fa6"/></svg></span>',
		          	nextArrow : '<span class="slick-next slick-arrow cursor-pointer absolute right-0 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><g  transform="translate(26.599)"><path d="M-25.9,32h9.96a.7.7,0,0,0,.491-.2L-.2,16.512a.7.7,0,0,0,0-.982L-15.439.206A.7.7,0,0,0-15.932,0h-9.963a.7.7,0,0,0-.643.428.7.7,0,0,0,.15.758l14.51,14.589a.348.348,0,0,1,0,.491L-26.394,30.812a.7.7,0,0,0-.151.759A.7.7,0,0,0-25.9,32Z" fill="#7f9fa6"/></g></svg></span>',
		          	responsive: [
						{
							breakpoint: 1488,
							settings: {
							slidesToShow: 6,
								slidesToScroll: 6,
							}
						},
						{
							breakpoint: 1280,
							settings: {
							slidesToShow: 5,
								slidesToScroll: 5,
							}
						},
						{
							breakpoint: 1024,
							settings: {
							slidesToShow: 4,
								slidesToScroll: 4,
							}
						},
						{
							breakpoint: 768,
							settings: {
							slidesToShow: 3,
								slidesToScroll: 3,
							}
						},
						{
							breakpoint: 640,
							settings: {
							slidesToShow: 2,
								slidesToScroll: 2,
							}
						}
		          	],
		          	mobileFirst: true
		      	});
		    }
		} else {
			if($('.logo-slider').hasClass('slick-initialized')) {
			  	$('.logo-slider').slick("unslick");
			}
		}
	}

	slickSliderWithResize();

	$('.testimonial-slider').slick({
	    dots: true,
	    infinite: false,
	    speed: 500,
		slidesToShow: 1,
	    slidesToScroll: 1,
	    adaptiveHeight: true,
	    prevArrow : '<span class="slick-testimonial-prev slick-arrow cursor-pointer absolute -left-2 xl:-left-20 lg:-left-10 md:-left-4 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><path d="M25.9,32h-9.96a.7.7,0,0,1-.491-.2L.2,16.512a.7.7,0,0,1,0-.982L15.439.206A.7.7,0,0,1,15.932,0h9.963a.7.7,0,0,1,.494,1.187L11.879,15.776a.348.348,0,0,0,0,.491L26.394,30.812A.7.7,0,0,1,25.9,32Z" fill="#7f9fa6"/></svg></span>',
	    nextArrow : '<span class="slick-testimonial-next slick-arrow cursor-pointer absolute -right-2 xl:-right-20 lg:-right-10 md:-right-4 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><g  transform="translate(26.599)"><path d="M-25.9,32h9.96a.7.7,0,0,0,.491-.2L-.2,16.512a.7.7,0,0,0,0-.982L-15.439.206A.7.7,0,0,0-15.932,0h-9.963a.7.7,0,0,0-.643.428.7.7,0,0,0,.15.758l14.51,14.589a.348.348,0,0,1,0,.491L-26.394,30.812a.7.7,0,0,0-.151.759A.7.7,0,0,0-25.9,32Z" fill="#7f9fa6"/></g></svg></span>',
	    // responsive: [
	    //     {
	    //         breakpoint: 1300,
	    //         settings: {
	    //             slidesToShow: 2,
					// slidesToScroll: 2,
	    //         }
	    //     },
	    //     {
	    //         breakpoint: 640,
	    //         settings: {
	    //             slidesToShow: 1,
					// slidesToScroll: 1,
	    //         }
	    //     }
	    // ]
	});

	$('.carousel-cards').each(function(index, el) {
		if ($(this).children().length > 1) {
			$(this).slick({
			    dots: true,
			    infinite: true,
			    speed: 300,
			    slidesToShow: 4,
			    prevArrow : '<span class="slick-prev slick-arrow cursor-pointer absolute -left-8 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><path d="M25.9,32h-9.96a.7.7,0,0,1-.491-.2L.2,16.512a.7.7,0,0,1,0-.982L15.439.206A.7.7,0,0,1,15.932,0h9.963a.7.7,0,0,1,.494,1.187L11.879,15.776a.348.348,0,0,0,0,.491L26.394,30.812A.7.7,0,0,1,25.9,32Z" fill="#7f9fa6"/></svg></span>',
			    nextArrow : '<span class="slick-next slick-arrow cursor-pointer absolute -right-8 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><g  transform="translate(26.599)"><path d="M-25.9,32h9.96a.7.7,0,0,0,.491-.2L-.2,16.512a.7.7,0,0,0,0-.982L-15.439.206A.7.7,0,0,0-15.932,0h-9.963a.7.7,0,0,0-.643.428.7.7,0,0,0,.15.758l14.51,14.589a.348.348,0,0,1,0,.491L-26.394,30.812a.7.7,0,0,0-.151.759A.7.7,0,0,0-25.9,32Z" fill="#7f9fa6"/></g></svg></span>',
			    responsive: [
			        {
			            breakpoint: 1380,
			            settings: {
			                slidesToShow: 3,
			            }
			        },
			        {
			            breakpoint: 768,
			            settings: {
			                slidesToShow: 2,
			            }
			        },
			        {
			            breakpoint: 640,
			            settings: {
			                slidesToShow: 1,
			            }
			        }
			    ]
			});
		}
	});

	$('ul.jsDynamicTabs').each(function(index, val) {
	     var _this = $(this);

	    _this.find('li a').click(function(){
	        var tab_id = $(this).attr('data-tab');

	        _this.find('li a').removeClass('active');
	        _this.parents('.tabHeader').siblings('.tabBody').children('.jsTabContent').removeClass('active');

	        $(this).addClass('active');
	        $("#" + tab_id).addClass('active');
	    });
	});

	$('.hero-general-slider').each(function(index, el) {
		if ($(this).find('img').length > 1) {
			$(this).slick({
			    dots: false,
			    infinite: true,
			    speed: 300,
			    slidesToShow: 1,
			    prevArrow : '<span class="slick-prev slick-arrow cursor-pointer absolute -left-8 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><path d="M25.9,32h-9.96a.7.7,0,0,1-.491-.2L.2,16.512a.7.7,0,0,1,0-.982L15.439.206A.7.7,0,0,1,15.932,0h9.963a.7.7,0,0,1,.494,1.187L11.879,15.776a.348.348,0,0,0,0,.491L26.394,30.812A.7.7,0,0,1,25.9,32Z" fill="#7f9fa6"/></svg></span>',
			    nextArrow : '<span class="slick-next slick-arrow cursor-pointer absolute -right-8 z-10" ><svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26.599 32"><g  transform="translate(26.599)"><path d="M-25.9,32h9.96a.7.7,0,0,0,.491-.2L-.2,16.512a.7.7,0,0,0,0-.982L-15.439.206A.7.7,0,0,0-15.932,0h-9.963a.7.7,0,0,0-.643.428.7.7,0,0,0,.15.758l14.51,14.589a.348.348,0,0,1,0,.491L-26.394,30.812a.7.7,0,0,0-.151.759A.7.7,0,0,0-25.9,32Z" fill="#7f9fa6"/></g></svg></span>',
			});
		}
	});

	$(".alphabet-sort").on("change", function(event) {
		event.preventDefault();
		$('#sort').submit();
	});

	$(document).on('click', '.select-custom-selection', function(event) {
		event.preventDefault();
		$(this).parents('.select-custom:first').find('.select-custom-list').slideToggle(100);
	});

	$(document).on('click', function (e) {
	    if ($(e.target).closest(".select-custom").length === 0) {
	        $('.select-custom-list').slideUp(100);
	    }
	});

	var $input = $('.aj-q');
	var typingTimer;
	$input.on('keyup', function (e) {
		clearTimeout(typingTimer);

		var _this = $(this);
		typingTimer = setTimeout(function() {
			var searchVal = $input.val();
			providerFilter(searchVal);
		}, 500);
	});

	$input.on('keydown', function () {
		clearTimeout(typingTimer);
	});

	$(document).on('click', '.nv-item', function(event) {
		event.preventDefault();
		var wrapper = $(this).parents('.select-custom:first');

        wrapper.find('.select-custom-selection').html($(this).html());
        wrapper.find('.select-custom-selection').attr('data-value', $(this).data('value'));
        console.log("called")
        // console.log(this);
        var link = $(this).data('link');
        var target = $(this).data('target');

        if (link != "") {
        	$(this).parents('.select-custom:first').find('.hero-trigger').attr({
        		href: link,
        	});
            window.open(link, target).focus();
        } else {
            $(this).parents('.select-custom:first').find('.hero-trigger').attr({
            	href: 'javascript:;',
            	target: ''
            });
        }

        wrapper.find('.select-custom-list').slideUp(100);

        if (wrapper.find(".select-custom-selection[data-type='category']:first").length)
        {
        	var catVal = wrapper.find(".select-custom-selection[data-type='category']:first").attr('data-value');
        	$('.loading').show();
        	$.ajax({
        		url: '/ajax/treatment',
        		type: 'GET',
        		dataType: 'html',
        		data: {category: catVal},
        	})
        	.done(function(data) {
        		console.log('Comes here')
        		$('.treatment-area-list').html(data).show();
        		providerFilter();
        	})
        	.fail(function() {
        		$('.loading').hide();
        		console.log("error");
        	})
        	.always(function() {
        		console.log("complete");
        	});
        }
        else
        {
        	providerFilter();
        }
	});

	// select-customselect-customselect-custom
	/*$('.select-custom').each(function(){
        var that = $(this),
        ddList = that.find('.select-custom-list'),
        selection = that.find('.select-custom-selection');

        selection.click(function(){
            ddList.slideToggle();
        });

        $(".select-custom").click(function(e){
            e.stopPropagation();
        });

        $('body').click(function(){
            ddList.slideUp();
        });

        ddList.find('a').click(function(e){
			e.preventDefault();
            selection.html($(this).html());
            selection.attr('data-value', $(this).data('value'));

            // console.log(this);
            var link = $(this).data('link');
            var target = $(this).data('target');

            if (link != "") {
            	$(this).parents('.select-custom:first').find('.hero-trigger').attr({
            		href: link,
            	});
	            window.open(link, target).focus();
            } else {
	            $(this).parents('.select-custom:first').find('.hero-trigger').attr({
	            	href: 'javascript:;',
	            	target: ''
	            });
            }

            ddList.slideUp();

            providerFilter();
        });
    });*/

    $('#video').on('click', function(event) {
    	event.preventDefault();
    	var source = $(this).data('src');
    	$(".replace").html("<iframe width='600' height='300' src='"+ source +"' frameborder='1' allowfullscreen></iframe>");
    });

    $(document).on('click', '.accordion', function(event) {
    	$(this).find(".accordion-content").toggleClass("hidden")
        $(this).find(".chevron").toggleClass("hidden")
    });

    // --------------------
    // Infinite Scroll
    // --------------------
    var infiniteLast = false;
    $('.infiniteJs').each(function(index, el) {
        var id = $(this).data('id');
        var pagination = ".next-" + id;

        if($(pagination).length)
        {
	        var _this = $('#wrapper-' + id);
	        var post = ".post-" + id;
	        var statusWrapper = ".page-load-status-" + id;
	        var viewMore = ".view-more-" + id;
	        _this.infiniteScroll({
	            path: pagination,
	            append: post,
	            history: false,
	            button: viewMore,
	            scrollThreshold: false,
	            status: statusWrapper,
	        });

	        _this.on( 'request.infiniteScroll', function( event, path, fetchPromise ) {
	            _this.parents().find(viewMore).hide();
	        });

	        _this.on( 'load.infiniteScroll', function( event, body, path, response ) {
	            if(! infiniteLast)
	            {
	                setTimeout(function() {
	                    _this.parents().find(viewMore).show();
	                }, 200);
	            }
	            else
	            {
	                infiniteLast = false;
	            }
	        });

	        _this.on( 'last.infiniteScroll', function( event, body, path ) {
	            infiniteLast = true;
	            _this.parents().find(viewMore).hide();

	            setTimeout(function() {
	                $(statusWrapper).fadeOut();
	            }, 5000);
	        });
        }
    });

    $('.urgentCareJs').each(function(index, el) {
    	var facilityId = $(this).data('expressid');
    	var facilityName = $(this).data('name');
    	if(facilityId){
	        var apiUrl = 'https://apps10.erexpress.com/erx-reservationform/api/firstavailable/' + facilityId + '?callback=?';
	        $.getJSON( apiUrl, function( data ) {
	            if (facilityName) {
	            	$('.' + facilityName).find('.first').html(data.reservationTime);
	            }
	        });
    	}
    });

    $('.sorting-filter').on('change', function(event) {
    	event.preventDefault();
        providerFilter();
    });

    /*$('.video-sorting-filter').on('change', function(event) {
    	event.preventDefault();
        videoFilter();
    });*/

    $('.reset-btn').on('click', function(event) {
    	event.preventDefault();
    	reset = true;
		$(".select-custom-selection[data-type='category']").attr('data-value', '').html('Specialty');
		$(".select-custom-selection[data-type='treatment']").attr('data-value', '').html('Treatment Areas');
		$(".select-custom-selection[data-type='location']").attr('data-value', '').html('Location');
		$("input[name=sort][value='atoz']").prop("checked",true);
		$("input[name=search]").val("");
    	var searchVal = '';
    	var catVal = '';
		var locVal = '';
		var treatVal = '';
		var sortVal = '';
		providerFilter();
    });

    /*$('.video-reset-btn').on('click', function(event) {
    	event.preventDefault();
    	reset = true;
		$(".select-custom-selection[data-type='topic']").attr('data-value', '').html('Topic');
		$(".select-custom-selection[data-type='subtopic']").attr('data-value', '').html('Sub Topic');
		$("input[name=sort][value='atoz']").prop("checked",true);
		var searchVal = '';
    	var topicVal = '';
		var subtopicVal = '';
		var sortVal = '';
		videoFilter();
    });*/

    $(document).on('click', '.close-anouncement', function(event) {
    	event.preventDefault();

    	var list = getCookie("visited-anouncements");
    	if(list == "") {
    		list = [];
    	} else {
    		list = JSON.parse(list);
    	}

    	list.push($(this).data('id'));
    	setCookie("visited-anouncements", JSON.stringify(list), 3);

    	$(this).parent().remove();
    });
});

function providerFilter(searchVal)
{
	var catVal;
	var locVal;
	var treatVal;
	var sortVal;
	var parentCatValue = $('.select-custom-selection').closest(".select-custom").attr('data-cat-value');
	var parentCatClass = (parentCatValue == 'video') ? '.video-data' : '.provider-data';

	if ($(".select-custom-selection[data-type='category']").length) {
		catVal = $(".select-custom-selection[data-type='category']").attr('data-value');
	}
	if ($(".select-custom-selection[data-type='location']").length) {
		locVal = $(".select-custom-selection[data-type='location']").attr('data-value');
	}
	if ($(".select-custom-selection[data-type='treatment']").length) {
		treatVal = $(".select-custom-selection[data-type='treatment']").attr('data-value');
	}
	if ($(".select-custom-selection[data-type='search']").length) {
		searchVal = $(".select-custom-selection[data-type='search']").attr('data-value');
	}
	if ($('.sorting-filter').val().length) {
		sortVal = $('.sorting-filter:checked').val();
	}

	params = {
		category: catVal,
		treatment: treatVal,
		location: locVal,
		s: searchVal,
		sort: sortVal
	};

	// console.log(params);
	// console.log(reset);
	if(reset)
	{
		var newurl = window.location.origin + window.location.pathname;
		params = {};
		reset = false;
	}
	else
	{
		var newurl = window.location.origin + window.location.pathname + "?" + $.param(params);
	}
	window.history.pushState({path:newurl},'',newurl);

	$('.loading').show();

	$.ajax({
	    url: '/ajax/' + parentCatValue,
	    type: 'GET',
	    dataType: 'html',
	    cache: true,
	    data: params,
	})
	.done(function(data, status, xhr) {
	    console.log('AJAX finished. Showing Results to ' + parentCatValue + ' container')
	    // $('.instructions').hide();
	    $(parentCatClass).html(data).show();

        infiniteScroll();

	    // fitContent();
	    // $("html, body").animate({
	    //     scrollTop: $('.py-50.py-md-100.content-width').offset().top - 50
	    // }, "fast");
	})
	.fail(function() {
	    console.log("AJAX Failed. Please review the query and feed template");
	})
	.always(function() {
	    $('.loading').hide();
	    console.log("Hiding Loading bar.");
	});
}

/*function videoFilter(searchVal)
{
	var topicVal;
	var subtopicVal;
	var sortVal;

	if ($(".select-custom-selection[data-type='category']").length) {
		catVal = $(".select-custom-selection[data-type='category']").attr('data-value');
	}
	if ($(".select-custom-selection[data-type='treatment']").length) {
		treatVal = $(".select-custom-selection[data-type='treatment']").attr('data-value');
	}
	if ($('.sorting-filter').val().length) {
		sortVal = $('.sorting-filter:checked').val();
	}
	if ($(".select-custom-selection[data-type='search']").length) {
		searchVal = $(".select-custom-selection[data-type='search']").attr('data-value');
	}

	params = {
		topic: topicVal,
		subtopic: subtopicVal,
		s: searchVal,
		sort: sortVal,

	};

	// console.log(params);
	// console.log(reset);
	if(reset)
	{
		var newurl = window.location.origin + window.location.pathname;
		params = {};
		reset = false;
	}
	else
	{
		var newurl = window.location.origin + window.location.pathname + "?" + $.param(params);
	}
	window.history.pushState({path:newurl},'',newurl);

	$('.loading').show();

	$.ajax({
	    url: '/ajax/video',
	    type: 'GET',
	    dataType: 'html',
	    cache: true,
	    data: params,
	})
	.done(function(data, status, xhr) {
	    console.log('AJAX finished. Showing Results to provider container')
	    // $('.instructions').hide();
	    $('.video-data').html(data).show();
	    // fitContent();
	    // $("html, body").animate({
	    //     scrollTop: $('.py-50.py-md-100.content-width').offset().top - 50
	    // }, "fast");
	})
	.fail(function() {
	    console.log("AJAX Failed. Please review the query and feed template");
	})
	.always(function() {
	    $('.loading').hide();
	    console.log("Hiding Loading bar.");
	});
}*/

function infiniteScroll() {
    var infiniteLast = false;
    $('.infiniteJs').each(function(index, el) {
		console.log('hegywhegbyw');
        var id = $(this).data('id');
        var pagination = ".next-" + id;

        if($(pagination).length)
        {
	        var _this = $('#wrapper-' + id);
	        var post = ".post-" + id;
	        var statusWrapper = ".page-load-status-" + id;
	        var viewMore = ".view-more-" + id;
	        _this.infiniteScroll({
	            path: pagination,
	            append: post,
	            history: false,
	            button: viewMore,
	            scrollThreshold: false,
	            status: statusWrapper,
	        });

	        _this.on( 'request.infiniteScroll', function( event, path, fetchPromise ) {
	            _this.parents().find(viewMore).hide();
	        });

	        _this.on( 'load.infiniteScroll', function( event, body, path, response ) {
	            if(! infiniteLast)
	            {
	                setTimeout(function() {
	                    _this.parents().find(viewMore).show();
	                }, 200);
	            }
	            else
	            {
	                infiniteLast = false;
	            }
	        });

	        _this.on( 'last.infiniteScroll', function( event, body, path ) {
	            infiniteLast = true;
	            _this.parents().find(viewMore).hide();

	            setTimeout(function() {
	                $(statusWrapper).fadeOut();
	            }, 5000);
	        });
        }
    });
}

function sleep(sleepDuration){
    var now = new Date().getTime();
    while(new Date().getTime() < now + sleepDuration){
        /* Do nothing */
    }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}